import { paymentMethodTypes } from 'constants/companyConstants';

export const parsePaymentMethod = (card) => {
  const {
    id,
    exp_year: expYear,
    exp_month: expMonth,
    last_four: lastFour,
    ref_po_number: poNumber,
    billing_type: billingType,
    email,
    phone,
    full_name: fullName,
    signature,
    address,
    city,
    state,
  } = card;

  const fullAddressArray = [address, city, state].filter((el) => el);

  return {
    id,
    lastFour,
    expMonth,
    expYear,
    phone,
    email,
    billingType: billingType?.toLowerCase() || paymentMethodTypes.CARD,
    poNumber,
    fullName,
    signature,
    fullAddress: fullAddressArray.join(', '),
  };
};
